import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AssistantRoutingModule } from './assistant-routing.module';
import { IaAssistantComponent } from './components/ia-assistant/ia-assistant.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { SafeHtmlDirective } from 'src/app/share/directives/safe-html.directive';
import { SharedModule } from "src/app/share/shared.module";
import { ClipboardDirective } from 'src/app/share/directives/clipboard.directive';
import { VoiceActivityIndicatorComponent } from 'src/app/share/components/voice-activity-indicator/voice-activity-indicator.component';


@NgModule({
  declarations: [IaAssistantComponent],
  imports: [
    CommonModule,
    AssistantRoutingModule,
    IonicModule,
    FormsModule, SafeHtmlDirective,
    SharedModule,
    ClipboardDirective,
    VoiceActivityIndicatorComponent
],
  exports: [IaAssistantComponent]
})
export class AssistantModule { }
